import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Youtube = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size, ...rest }, ref) => {
  return (
    <svg
      width={size ?? 20}
      height={size ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1667 8.09165C19.2079 6.89886 18.947 5.715 18.4083 4.64999C18.0428 4.21299 17.5356 3.91808 16.975 3.81665C14.6563 3.60626 12.3279 3.52002 10 3.55832C7.68054 3.51829 5.36059 3.60174 3.05 3.80832C2.59319 3.89142 2.17043 4.10569 1.83334 4.42499C1.08334 5.11665 1 6.29999 0.916669 7.29999C0.795762 9.09796 0.795762 10.902 0.916669 12.7C0.940777 13.2628 1.02458 13.8215 1.16667 14.3667C1.26715 14.7875 1.47044 15.1769 1.75834 15.5C2.09773 15.8362 2.53032 16.0627 3 16.15C4.7966 16.3718 6.60685 16.4637 8.41667 16.425C11.3333 16.4667 13.8917 16.425 16.9167 16.1917C17.3979 16.1097 17.8427 15.8829 18.1917 15.5417C18.425 15.3082 18.5992 15.0226 18.7 14.7083C18.998 13.7938 19.1444 12.8367 19.1333 11.875C19.1667 11.4083 19.1667 8.59165 19.1667 8.09165ZM8.11667 12.375V7.21665L13.05 9.80832C11.6667 10.575 9.84167 11.4417 8.11667 12.375Z"
        fill={color}
      />
    </svg>
  );
});

export default Youtube;
